// extracted by mini-css-extract-plugin
export default {"best_offer_image_picker":"image-picker_best_offer_image_picker__NKh8v","uploader":"image-picker_uploader__BsLn-","info":"image-picker_info__Lej9I"};